import type { IAssignmentRepository } from '@/core/domain/school/assignment/IAssignmentRepository'
import type { Assignment } from '@/core/domain/school/assignment/Assignment'
import type { AssignmentInputEntity } from '@/core/infrastructure/schemas/school/assignment/AssignmentSchema'

/**
 * Use case pour mettre à jour un assignment existant
 */
export class UpdateAssignmentUseCase {
  private readonly assignmentRepository: IAssignmentRepository

  constructor(assignmentRepository: IAssignmentRepository) {
    this.assignmentRepository = assignmentRepository
  }

  async execute(
    schoolId: number,
    periodId: number,
    assignmentId: number,
    assignment: AssignmentInputEntity
  ): Promise<Assignment> {
    return await this.assignmentRepository.updateAssignment(
      schoolId,
      periodId,
      assignmentId,
      assignment
    )
  }
}
